import React from 'react';
import BasketballMatchRecordTableItem from './item';
import { Contents, Header, Date, Location, Odds } from './styled';
import clsx from 'clsx';

const BasketballMatchRecordTable = ({ data }) => {
  return (
    <Contents>
      <Header>
        <div className="game">
          <div className="date">일시</div>
          <Location>
            <div className={clsx('team', 'home')}>
              <span>홈팀</span>
            </div>
            <div className="score" style={{ justifyContent: 'center' }}>
              <span>점수</span>
            </div>
            <div className={clsx('team', 'away')}>
              <span>원정팀</span>
            </div>
          </Location>
          <Odds>
            <span>배당률</span>
          </Odds>
        </div>
      </Header>
      {data.length > 0 &&
        data.map((item, idx) => (
          <BasketballMatchRecordTableItem item={item} key={`${idx}`} />
        ))}
    </Contents>
  );
};

export default BasketballMatchRecordTable;
